export const Spain = {
    MODULE: { LABEL: 'Acceso' },
    LOGIN: {
        SEO_TITLE: 'Administrar portfolio',
        SEO_DESCRIPTION: 'Acceso privado al panel de administración del portfolio.',
        STATUS: '',
        EYEBROW: '',
        TITLE: '',
        TITLE_ACCENT: '',
        DESCRIPTION: '',
        CARD_EYEBROW: '',
        CARD_TITLE: 'Acceso autorizado',
        CARD_SUBTITLE: '',
        SUBMIT: 'Ingresar',
        SUBMIT_LOADING: 'Verificando acceso',
    },
    FIELDS: {
        EMAIL_LABEL: 'Correo electrónico',
        EMAIL_PLACEHOLDER: 'Correo electrónico',
        PASSWORD_LABEL: 'Contraseña',
        PASSWORD_PLACEHOLDER: 'Contraseña',
        REMEMBER_ME: 'Recordarme',
    },
};
